// showSupportCodeToast runs outside React (it is raised from lib/api/utils.ts),
// and sonner renders the toast under the root layout's <Toaster>, above
// NextIntlClientProvider — so the toast cannot translate itself.
// <SupportCodeToastInitializer/> keeps this wording in step with the page's
// locale; the English defaults only cover the moment before it mounts.
export interface ISupportCodeToastTexts {
    title: string;
    description: (code: string) => string;
}

let texts: ISupportCodeToastTexts = {
    title: 'Something went wrong.',
    description: (code) => `Support code: ${code} — tap to copy`,
};

export const getSupportCodeToastTexts = () => texts;

export const setSupportCodeToastTexts = (next: ISupportCodeToastTexts) => {
    texts = next;
};
